import ScrollToTop from '../js/scrollToTop';
import SmoothScroll from '../js/smoothScroll';
import OverlayMenu from '../js/overlayMenu';
import StaffInterviewAccordion from '../js/staffInterviewAccordion';
import TopPageOpeningSlider from '../js/topPageOpeningSlider';
import TopPageStickyHeader from '../js/topPageStickyHeader';

/* JavaScript */
document.addEventListener('DOMContentLoaded', () => {
    ScrollToTop();
    SmoothScroll();
    OverlayMenu();
    StaffInterviewAccordion();
    TopPageOpeningSlider();
    TopPageStickyHeader();
});
